<script setup>
  import ArrowRight from '@/assets/icons/sidebar/arrow-right.svg'

  import { useClubRegisterStore } from '@/features/clubRegister/views/useClubRegisterStore.js'
  import { setActiveClubId } from '@/features/router/useActiveClub.js'
  import { useClubRouter } from '@/features/router/useClubRouer.js'
  import ClubLogoById from '@/features/ui/components/club/ClubLogoById.vue'

  const props = defineProps({
    title: String,
    desc: String,
    clubId: String,
    finalized: Boolean,
  })

  const clubRegisterStore = useClubRegisterStore()

  const router = useClubRouter()

  async function handleSelectClub() {
    if (!props.finalized) {
      clubRegisterStore.setCurrentStep(clubRegisterStore.STEPS.ORG_DETAILS, props.clubId)
      return
    }

    console.log('reloading the page club changed')

    setActiveClubId(props.clubId)
    await router.push('/')

    window.location.reload()
  }
</script>

<template>
  <div v-if="finalized" class="profile-club-selector-item" @click.prevent="handleSelectClub">
    <div class="club-image">
      <ClubLogoById :club-id="clubId" />
    </div>
    <div class="club-info">
      <div class="title">
        {{ title || $t('draftTenant') }}
      </div>
    </div>
    <div class="arrow">
      <ArrowRight />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .profile-club-selector-item {
    display: flex;
    gap: 20px;
    padding: 5px 0;
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 4px;

    &:hover {
      background-color: var(--p-surface-100);
    }
  }

  .club-image {
    width: 40px;

    img {
      width: 100%;
    }
  }

  .club-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    justify-content: center;

    .title {
      font-size: 12px;
    }

    .desc {
      font-size: 10px;
      color: light-dark(#c0c0c0, #c0c0c0);
    }
  }

  .arrow {
    color: light-dark(#c0c0c0, #c0c0c0);
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
